export default __webpack_public_path__ + "static/media/bottom_ui_panel.8314f3de.png";